import { useContext } from 'react'

import { Stack, Grid } from '@mui/material'

import { CardTitle, FplDynamicTabs, TabPanelBootstrap } from 'components/common'

import { ReadOnlyBookingAddressType } from '.'
import { AddressContext } from './AddressProvider'
import { ReadOnlyBookingAddress } from './ReadOnlyBookingAddress'

interface ISupplierCollectionAddressProps {
  addresses: ReadOnlyBookingAddressType[]
}

export const SupplierCollectionAddress = (props: ISupplierCollectionAddressProps) => {
  const { addresses } = props
  const { collectionTabValue, setCollectionTabValue } = useContext(AddressContext)
  const handleTabChange = (_, newValue) => {
    setCollectionTabValue(newValue)
  }
  return (
    <Stack spacing={1.5}>
      <Grid container columnSpacing={1.5} justifyContent='space-between'>
        <Grid item>
          <CardTitle marginBottom={0}>Collection</CardTitle>
        </Grid>
      </Grid>

      <Stack>
        <FplDynamicTabs
          tabValue={collectionTabValue}
          fields={addresses}
          name='collection-address'
          onTabChange={handleTabChange}
          label={'ADD'}
          showRemoveButton={false}
          showAddButton={false}
          disabled={undefined}
          onAddClick={undefined}
        />

        {addresses.map((item, index) => (
          <TabPanelBootstrap value={collectionTabValue} index={index} key={item.tabsKey}>
            <ReadOnlyBookingAddress
              address={item}
              key={item.tabsKey}
              labelAt='Ready At'
              labelBy='Collect By'
            />
          </TabPanelBootstrap>
        ))}
      </Stack>
    </Stack>
  )
}
